import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventGoal extends DomainEvent<MatchEvent> {}
